export default __webpack_public_path__ + "static/media/banner2.f176d4a8.jpg";